import styled from 'styled-components';

export const StyledList = styled.ul`
  width: 100%;
  height: 70vh;
  overflow: hidden;
  overflow-y: scroll;
`;
